/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { useParams, useSearchParams } from 'react-router'
import { DocumentsListPage } from './DocumentsListPage'
import { DOCUMENTS_VIEW_TYPE } from './types'

export const PropertySearchPage: React.FC = () => {
  const { folderId } = useParams<{ folderId: string }>()
  const [searchParams] = useSearchParams()

  // Read filter ID from URL query parameter (propertySearchFilter)
  const urlFilterId = searchParams.get('propertySearchFilter') || undefined

  return (
    <DocumentsListPage
      key={`propertySearch-${folderId || 'root'}-${urlFilterId || 'no-filter'}`}
      viewType={DOCUMENTS_VIEW_TYPE.propertySearch}
      folderId={folderId}
      urlFilterId={urlFilterId}
    />
  )
}
